<template>
  <div class="w-full flex flex-col">
    <ul
      role="list"
      class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-3 4xl:grid-cols-4 5xl:grid-cols-5"
      v-if="!initializeLoading"
    >
      <V4LearningPathGridCard
        v-for="playlist in learningPath"
        :key="playlist.id"
        :pathId="playlist.learning_path_id"
        :title="playlist.title"
        :thumbnail="playlist.thumbnail"
        :totalVideosCompleted="playlist.total_completed_videos_count"
        :totalVideoDuration="playlist.total_learning_path_duration"
        :totalVideos="playlist.total_videos_count"
        :dueDate="playlist.due_date"
        :contents="playlist.contents"
        :isOwner="playlist.is_owner"
        :startDate="playlist.start_date"
        :type="playlist.type"
        :totalProgress="playlist.total_progress_percentage"
        :isSuperAdmin="isSuperAdmin"
        :isCompanyAdmin="isCompanyAdmin"
        :isManager="isManager"
        :isLearner="isLearner"
        :featured="playlist.is_featured"
      />
    </ul>
    <V4LoadingPlaylist
      v-if="initializeLoading || loadingLearningPath"
      :showCategories="false"
      class="mt-4"
      :data="loadingLearningPathData"
    />
    <EmptyData
      v-if="
        !initializeLoading && !loadingLearningPath && learningPath.length === 0
      "
      description="No Learning Path Available."
    />
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores";
import { useHomeLearningPathStore } from "@/stores/home/useHomeLearningPath.store";
import { computed } from "vue";
import { storeToRefs } from "pinia";
import EmptyData from "@/components/utilities/EmptyData.vue";
import { defineOptions } from "vue";
import V4LearningPathGridCard from "./V4LearningPathGridCard.vue";
import V4LoadingPlaylist from "../V4LoadingPlaylist.vue";

defineOptions({
  inheritAttrs: false,
});

const authUserStore = useAuthStore();

const homeLearningPathStore = useHomeLearningPathStore();
const { learningPath, initializeLoading, loadingLearningPath } = storeToRefs(
  homeLearningPathStore
);

const loadingLearningPathData = computed(() => []);
const isSuperAdmin = computed(() => authUserStore.isSuperAdmin);
const isManager = computed(() => authUserStore.isDealerManager);
const isCompanyAdmin = computed(() => authUserStore.isAccountManager);

const isLearner = computed(() => {
  return (
    !authUserStore.isSuperAdmin &&
    !authUserStore.isDealerManager &&
    !authUserStore.isAccountManager &&
    !authUserStore.isMultiStoreManager
  );
});
</script>

<style lang="scss" scoped></style>
